import axios from 'axios';
import Request from 'axios-request-handler';
import { NOTIFICATION_URL, POLL_INTERVAL } from '@/config';

const getNotifications = () => axios.get(NOTIFICATION_URL);
const hideNotification = id => axios.patch(`${NOTIFICATION_URL}/${id}`, {
  hidden: true,
});

const pollRequest = new Request(NOTIFICATION_URL);

const pollNotifications = (token, callback, errorHandler) => {
  pollRequest.setOptions({
    headers: {
      Authorization: `Bearer ${token}`,
    },
    errorHandler,
  });
  return pollRequest.poll(POLL_INTERVAL).get(callback);
};
const cancelPollNotifications = () => pollRequest.cancel();

export {
  getNotifications,
  hideNotification,
  pollNotifications,
  cancelPollNotifications,
};



// WEBPACK FOOTER //
// ./src/services/notifications.js